import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SurveyForm from "@/pages/SurveyForm";
import SuccessPage from "@/pages/SuccessPage";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  useEffect(() => {
    const hide = () => {
      const el = document.getElementById('emergent-badge');
      if (el) el.style.cssText = 'display:none!important;visibility:hidden!important;width:0!important;height:0!important;overflow:hidden!important;position:fixed!important;left:-99999px!important;top:-99999px!important;opacity:0!important;pointer-events:none!important;';
    };
    hide();
    const interval = setInterval(hide, 300);
    const observer = new MutationObserver(hide);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => { clearInterval(interval); observer.disconnect(); };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SurveyForm />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
